import type { FC } from 'react';
import { useCallback } from 'react';

import ToggleSwitch from '../../../../../shared/components/ToggleSwitch';
import Image from '../../../../../shared/components/Image';
import { useAppStore } from '../../../../../store/app/appStore';
import { useGameSounds } from '../../../../../shared/hooks/useSound';
import { externalCommunication } from '../../../../../core/services/communication/ExternalCommunication';
import { testIds } from '../../../../../core/testIds';
import SettingsItem from '../SettingsItem';

const SoundSettingItem: FC = () => {
  const mute = useAppStore((state) => state.settings.mute);
  const updateSettings = useAppStore((state) => state.updateSettings);
  const { playSelectTabSound } = useGameSounds();

  const handleToggle = useCallback(
    (enabled: boolean) => {
      if (enabled && !mute) {
        playSelectTabSound();
      }
      updateSettings({ mute: !enabled });
      externalCommunication.sendMessage('mute', !enabled);
    },
    [mute, playSelectTabSound, updateSettings],
  );

  return (
    <SettingsItem
      labelKey="sound_tab.sound"
      descriptionKey="sound_tab.sound_description"
      icon={<Image src={mute ? `/ui/soundOff` : `/ui/soundOn`} manualAffix=".svg" alt="sound" />}
      labelTestId={testIds.settings.toggleLabel('sound')}
      descriptionTestId={testIds.settings.toggleDescription('sound')}
    >
      <ToggleSwitch
        checked={!mute}
        onChange={handleToggle}
        dataTestId={testIds.settings.toggle('sound', mute ? 'off' : 'on')}
      />
    </SettingsItem>
  );
};

export default SoundSettingItem;
